import { useEffect, useState } from 'react'
import { Header } from 'components/layout/header'
import { Main } from 'components/layout/main'
import { Search } from 'components/search'
import { clubManagersColumns } from 'helpers/club-manager-profile-columns'
import { GenericDataTable } from 'helpers/generic-data-table'
import { Loader } from 'lucide-react'
import {
  approveClubManager,
  fetchClubManagers,
  rejectClubManager,
} from 'store/clubManagers/clubManagersSlice'
import { useAppDispatch, useAppSelector } from 'store/store'

const ClubManagersPage = () => {
  const dispatch = useAppDispatch()
  const { loading, error, clubManagers, totalPages } = useAppSelector(
    (state) => state.clubManagers
  )

  const [pageIndex, setPageIndex] = useState(0) // React Table uses 0-based index
  const pageSize = 20

  useEffect(() => {
    dispatch(fetchClubManagers(pageIndex + 1))
  }, [dispatch, pageIndex])

  let content = <Loader className='h-5 w-5 animate-spin' />
  if (!loading) {
    if (error) {
      content = (
        <div className='uk-alert uk-alert-danger uk-text-center'>
          Errore: {error}
        </div>
      )
    } else if (clubManagers) {
      content = (
        <GenericDataTable
          columns={clubManagersColumns({
            onApprove: (clubManagerProfileId, notes) => {
              dispatch(approveClubManager({ clubManagerProfileId, notes }))
            },
            onReject: (clubManagerProfileId, notes) => {
              dispatch(rejectClubManager({ clubManagerProfileId, notes }))
            },
          })}
          data={clubManagers || []}
          pageCount={totalPages}
          pageIndex={pageIndex}
          pageSize={pageSize}
          onPageIndexChange={setPageIndex}
        />
      )
    }
  }

  return (
    <>
      {/* ===== Top Heading ===== */}
      <Header>
        <div className='ml-auto flex items-center space-x-4'>
          <Search />
        </div>
      </Header>

      {/* ===== Main ===== */}
      <Main>
        <div className='mb-2 flex flex-wrap items-center justify-between space-y-2 gap-x-4'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>Club Managers</h2>
            <p className='text-muted-foreground'>
              Pagina di gestione Club managers
            </p>
          </div>
        </div>
        <div className='-mx-4 mt-5 flex-1 overflow-auto px-4 py-1 lg:flex-row lg:space-y-0 lg:space-x-12'>
          {content}
        </div>
      </Main>
    </>
  )
}

export default ClubManagersPage
